// extracted by mini-css-extract-plugin
export default {"lock":"Main_lock__py91n","_lock":"Main__lock__Fu56K","root":"Main_root__Ys2hH","wrapper":"Main_wrapper__8+k+g","page":"Main_page__QqGwF","error-message":"Main_error-message__Z0+9n"};